import { TripClassPrice } from 'Services/Api/_HumanWritten/PricingService/PricingService';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import { cheapestHeadFare, PassengerCounts } from './tripClassFares';

/**
 * "from $10.00 pp" — the cheapest head on this booking, per class.
 *
 * <p>Per head in the header and a party total in the cells, deliberately: the header answers "what
 * does this class cost" once for the day, and the cell answers "what does my booking cost" on each
 * sailing. Blank where the site sells no passenger type this class has a fare for.</p>
 *
 * <p>Here rather than in <c>tripClassFares</c> because <c>formatPriceDisplay</c> reaches the store
 * and the store reaches <c>window</c>, which the node-environment unit tests do not have.</p>
 */
export const perHeadLabel = (classPrice: TripClassPrice, counts: PassengerCounts): string => {
	const cheapest = cheapestHeadFare(classPrice, counts);
	return cheapest === null ? '' : `from ${formatPriceDisplay(cheapest, false)} pp`;
};
